import { useEffect, useRef } from 'react'

export default function DNABackground() {
  const canvasRef = useRef(null)

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return
    const ctx = canvas.getContext('2d')
    let raf
    let t = 0

    const GOLD = 'rgba(201,168,76,'
    const WHITE = 'rgba(240,237,230,'

    const PAIRS = 22
    const AMP = 80
    const SPEED = 0.003

    function resize() {
      canvas.width = canvas.offsetWidth
      canvas.height = canvas.offsetHeight
    }

    function draw() {
      const W = canvas.width
      const H = canvas.height
      ctx.clearRect(0, 0, W, H)

      const cx = W * 0.5
      const FREQ = (Math.PI * 2) / H

      for (let strand = 0; strand < 2; strand++) {
        const phase = strand === 0 ? 0 : Math.PI
        ctx.beginPath()
        for (let py = 0; py <= H; py += 4) {
          const x = cx + Math.sin(FREQ * py * 1.8 + t + phase) * AMP
          py === 0 ? ctx.moveTo(x, py) : ctx.lineTo(x, py)
        }
        ctx.strokeStyle = strand === 0
          ? GOLD + '0.22)'
          : WHITE + '0.08)'
        ctx.lineWidth = 1
        ctx.stroke()
      }

      const segH = H / (PAIRS - 1)
      for (let i = 0; i < PAIRS; i++) {
        const y = i * segH
        const FREQ2 = (Math.PI * 2) / (segH * PAIRS)
        const x0 = cx + Math.sin(FREQ2 * y * (PAIRS * 1.8) + t) * AMP
        const x1 = cx + Math.sin(FREQ2 * y * (PAIRS * 1.8) + t + Math.PI) * AMP

        const sinV = Math.abs(Math.sin(FREQ2 * y * (PAIRS * 1.8) + t))
        const vis = sinV
        if (vis < 0.05) continue

        const alpha = 0.08 + vis * 0.22

        ctx.beginPath()
        ctx.moveTo(x0, y)
        ctx.lineTo(x1, y)
        ctx.strokeStyle = GOLD + alpha + ')'
        ctx.lineWidth = 0.75
        ctx.stroke()

        const pairs = [[x0, GOLD], [x1, WHITE]]
        pairs.forEach(([x, col]) => {
          const r = 2.5 + vis * 2.5
          ctx.beginPath()
          ctx.arc(x, y, r, 0, Math.PI * 2)
          ctx.fillStyle = col + (0.1 + vis * 0.35) + ')'
          ctx.fill()
          ctx.strokeStyle = col + (0.3 + vis * 0.4) + ')'
          ctx.lineWidth = 0.75
          ctx.stroke()
        })
      }

      const fadeW = ctx.createLinearGradient(0, 0, W, 0)
      fadeW.addColorStop(0, 'rgba(13,13,13,1)')
      fadeW.addColorStop(0.25, 'rgba(13,13,13,0)')
      fadeW.addColorStop(0.75, 'rgba(13,13,13,0)')
      fadeW.addColorStop(1, 'rgba(13,13,13,1)')
      ctx.fillStyle = fadeW
      ctx.fillRect(0, 0, W, H)

      const fadeH = ctx.createLinearGradient(0, 0, 0, H)
      fadeH.addColorStop(0, 'rgba(13,13,13,0.85)')
      fadeH.addColorStop(0.12, 'rgba(13,13,13,0)')
      fadeH.addColorStop(0.88, 'rgba(13,13,13,0)')
      fadeH.addColorStop(1, 'rgba(13,13,13,0.95)')
      ctx.fillStyle = fadeH
      ctx.fillRect(0, 0, W, H)
    }

    function loop() {
      t += SPEED
      draw()
      raf = requestAnimationFrame(loop)
    }

    resize()
    window.addEventListener('resize', resize)
    loop()

    return () => {
      cancelAnimationFrame(raf)
      window.removeEventListener('resize', resize)
    }
  }, [])

  return (
    <canvas
      ref={canvasRef}
      className="absolute inset-0 w-full h-full pointer-events-none"
      style={{ opacity: 0.75 }}
    />
  )
}